import { render } from "./NetworkError.vue?vue&type=template&id=674aec28&scoped=true"
import script from "./NetworkError.vue?vue&type=script&lang=js"
export * from "./NetworkError.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-674aec28"

export default script